import React from 'react'
import { Divider, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { getEnevelopeCompletedBySelf } from '@util/CommonServicess'

import DocWhiteSVG from '@assets/images/DocWhite.svg'
import ArrowSVG from '@assets/images/Arrow.svg'
import styles from './EnvelopActionPanel.styles'

interface EnvelopActionPanelProps {
    showActionLink?: boolean
    isCompleted?: boolean
    actionLink: string
    state: any
}

const EnvelopActionPanelDesktop: React.FC<EnvelopActionPanelProps> = ({
    showActionLink,
    isCompleted,
    actionLink,
    state,
}) => {
    const { t } = useTranslation()

    return (
        <>
            {showActionLink && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Divider orientation="vertical" />
                    <div style={{ marginLeft: '10px' }}>
                        {isCompleted ? (
                            <Button
                                variant="contained"
                                sx={styles.downloadButton}
                                endIcon={<img src={DocWhiteSVG} />}
                                onClick={() => window.open(actionLink, '_blank')}
                            >
                                {t('global.getDocuments')}
                            </Button>
                        ) : (
                            !getEnevelopeCompletedBySelf(state) && (
                                <Button
                                    variant="outlined"
                                    sx={styles.actionButton}
                                    endIcon={<img src={ArrowSVG} />}
                                    onClick={() => window.open(actionLink, '_blank')}
                                >
                                    {t('global.viewProgress')}
                                </Button>
                            )
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default EnvelopActionPanelDesktop
